// providers/salesforce.ts
import * as Api from '@ViewModels';
import { ConfigPath } from './constants';
import { lockableSelect, provider, searchableSelect, toggle } from './helpers';

export const salesforceConfig = provider(Api.IntegrationProvider.Salesforce, {
	displayName: 'Salesforce',

	main: {
		writebacks: true,
		fields: [
			toggle('preferNicknameAsFirstName', {
				label: 'Prefer Nickname as First Name',
				subtitle: 'Use the contact nickname from Salesforce as the first name in Levitate',
			}),
			lockableSelect('contactRecordType', ConfigPath.AVAILABLE_RECORD_TYPES, {
				label: 'Contact Record Type',
				subtitle: 'Controls which Salesforce record type to use for contact syncing (cannot be changed once set)',
			}),
			searchableSelect('deceasedField', ConfigPath.ALL_AVAILABLE_FIELDS, {
				label: 'Deceased Indicator',
				subtitle: 'Maps a Salesforce field to mark contacts as deceased',
			}),
		],
	},

	keyFacts: {
		birthdayDisplay: false,
		dateFields: true,
		customDateFields: true,
	},

	tags: {
		coreTags: false, // Salesforce uses field-based tags instead
		dynamicTags: true, // Uses availableFields -> enabledFields
		customFields: true,
		customSections: [
			{
				id: 'campaignTags',
				label: 'Campaign Tags',
				subtitle: 'Tag contacts based on their Salesforce Campaign membership',
				options: [{ id: 'nameEnabled', label: 'Name' }],
				storageType: 'nested',
				settingsKey: 'campaignTagSettings',
			},
		],
		extraFields: [
			searchableSelect('unsubscribeFields', ConfigPath.ALL_AVAILABLE_FIELDS, {
				label: 'Unsubscribe Indicators',
				subtitle: 'Maps Salesforce fields to mark contacts as unsubscribed',
				multiple: true,
			}),
		],
	},
});
